import {ChangeDetectionStrategy, Component, computed, effect, EventEmitter, Injectable, input, Output, signal, viewChild} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AksjeeierbokId, AksjeklasseMedDetaljerModell, AksjeklasseRessursClient} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {AksjeklasseRedigerListeKomponent} from "../aksjeklasse-rediger-liste/aksjeklasse-rediger-liste";
import {MatButtonModule} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {KortKomponent} from "web-ng2/delt/komponenter/kort/kort";
import {KortTittelKomponent} from "web-ng2/delt/komponenter/kort/kort-tittel/kort-tittel";
import {KortHandlingerKomponent} from "web-ng2/delt/komponenter/kort/kort-handlinger/kort-handlinger";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";
import {MatIconModule} from "@angular/material/icon";

const debug = initDebugger('AksjeklasseKomponent');

@Component({
    selector: 'aksjeklasser',
    templateUrl: 'aksjeklasser.html',
    styleUrl: 'aksjeklasser.scss',
    imports: [
        AksjeklasseRedigerListeKomponent,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        KortKomponent,
        KortTittelKomponent,
        KortHandlingerKomponent,
        HtmlFormatertKomponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AksjeklasserKomponent {

    kortKomp = viewChild.required(KortKomponent);

    aksjeeierbokId = input.required<AksjeeierbokId>();

    aksjeklasser = signal<AksjeklasseMedDetaljerModell[]>([]);
    aktiveKlasser = computed(() => this.aksjeklasser().filter(k => !k.arkivert));
    arkiverteKlasser = computed(() => this.aksjeklasser().filter(k => k.arkivert));

    viserArkiverteKlasser = signal(false);
    visning = signal(true);

    constructor(private avhengigheter: AksjeklasseKomponentAvhengigheter) {
        effect(() => {
            debug('laster aksjeklasser for', this.aksjeeierbokId());
            this.avhengigheter.hentAlle(this.aksjeeierbokId())
                .then(klasser => this.aksjeklasser.set(klasser));
        });
    }

    visDetaljer() {
        this.kortKomp().setSomAktivOgSkrollTil();
    }

    skjulDetaljer() {
        this.kortKomp().setSomIkkeAktiv();
        this.viserArkiverteKlasser.set(false);
    }

    rediger() {
        this.visning.set(false);
    }

    redigeringFerdig(oppdaterteKlasser: AksjeklasseMedDetaljerModell[] | null) {
        if (oppdaterteKlasser !== null) {
            this.aksjeklasser.set(oppdaterteKlasser);
        }
        this.visning.set(true);
        this.viserArkiverteKlasser.set(false);
        this.kortKomp().skrollTil();
    }
}

@Injectable()
export class AksjeklasseKomponentAvhengigheter {

    constructor(private aksjeklasseRessursClient: AksjeklasseRessursClient) {
    }

    hentAlle(aksjeeierbokId: AksjeeierbokId): Promise<AksjeklasseMedDetaljerModell[]> {
        return this.aksjeklasseRessursClient.hentAlle(aksjeeierbokId).somPromise();
    }
}
